import React from 'react';
import { Box, Typography } from '@mui/material';
import { useNav } from '../App';
import { C, SP, SZ } from '../theme';

const S = {
  root: {
    minHeight: '100vh', background: C.bgApp,
    padding: `16px ${SP.screenH}px`,
    display: 'flex', flexDirection: 'column', gap: `${SP.md}px`,
    paddingBottom: `${SZ.navHeight + SP.xl}px`,
  },
  topBar: { display: 'flex', alignItems: 'center', gap: `${SP.md}px`, paddingBottom: `${SP.xs}px` },
  backBtn: { fontSize: '20px', cursor: 'pointer', color: C.textMuted, lineHeight: 1, padding: '2px 4px' },
  pageTitle: { fontSize: '22px', fontWeight: 600, color: C.textPrimary, letterSpacing: '-0.3px' },
  card: { background: C.bgCard, border: `0.5px solid ${C.border}`, borderRadius: '14px', padding: `${SP.cardPad}px` },
  placeholder: { fontSize: '14px', color: C.textMuted, lineHeight: 1.7 },
  lastUpdated: { fontSize: '11px', color: C.textDisabled, marginTop: `${SP.sm}px` },
};

const PAGES = {
  terms: {
    title: 'Terms of Service',
    intro: 'These terms govern your use of Binko. By using the app you agree to these terms.',
  },
  privacy: {
    title: 'Privacy Policy',
    intro: 'This policy explains how Binko collects, uses, and protects your personal data.',
  },
  'game-rules': {
    title: 'Game Rules',
    intro: 'These rules govern participation in Binko trivia and in-chat games.',
  },
};

export default function Legal({ page }) {
  const navigate = useNav();
  const content = PAGES[page] || PAGES.terms;

  return (
    <Box sx={S.root}>
      <Box sx={S.topBar}>
        <Box sx={S.backBtn} onClick={() => navigate('/settings')}>‹</Box>
        <Typography sx={S.pageTitle}>{content.title}</Typography>
      </Box>

      <Box sx={S.card}>
        <Typography sx={S.placeholder}>
          {content.intro}
        </Typography>
        <Typography sx={{ ...S.placeholder, mt: `${SP.md}px` }}>
          Full content coming soon. Please check back later or contact us at support@binko.app for any questions.
        </Typography>
        <Typography sx={S.lastUpdated}>Last updated: March 2026</Typography>
      </Box>
    </Box>
  );
}
